import {useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {useForm} from '../../../shared/hooks/Form';

import {InvoiceService} from '../InvoiceService';
import {ToastService} from '../../../AppToast';

export const useDialogTaxAuthStatus = (props) => {

  const {invoice} = props;

  const [display, setDisplay] = useState(false);
  const [invoiceDetail, setInvoiceDetail] = useState({} as any);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [needUpdate, setNeedUpdate] = useState(false);

  const showTaxAuthStatus = () => {
    setMessage(null);
    setNeedUpdate(false);
    setInvoiceDetail({});
    if (invoice?.id) {
      InvoiceService.getDetail(invoice.id).then(detail => {
        if ([3, 4, 5].includes(detail?.sendTaxStatus)) {
          taxAuthStatuses.forEach(stt => {
            if (stt.invoiceStatus === detail?.invoiceStatus) {
              detail.originalStatusText = stt.label;
            }
          });
          detail.invoiceStatusText = '';
          setInvoiceDetail(detail);
          setValue(detail);
          setDisplay(true);
        } else {
          ToastService.error('Chức năng chỉ áp dụng với các hóa đơn có Trạng thái gửi CQT: Đang gửi, Thành công, Có lỗi');
        }
      });
    }
  }

  const {render: renderForm, setValue, getValue} = useForm({
    fields: [
      {field: 'sellerTaxCode', header: 'MST người bán', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'invoiceSerial', header: 'Ký hiệu', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'invoiceNumber', header: 'Số hóa đơn', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'invoiceDate', header: 'Ngày lập', type: 'Calendar', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'totalAmount', header: 'Tổng tiền thanh toán', type: 'InputNumber', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'originalStatusText', header: 'Trạng thái HĐ hiện tại', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'invoiceStatusText', header: 'Trạng thái HĐ tại CQT', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'invoiceStatus', type: 'hidden'},
      {field: 'id', type: 'hidden'}
    ],
    layout: 'Horizontal',
    disabled: true,
    formClassName: 'view'
  });

  const getTaxAuthStatus = () => {
    if (!submitting) {
      setSubmitting(true);
      setMessage(null);
      setNeedUpdate(false);

      const invoiceData = {...invoiceDetail};
      for (let key in invoiceData) {
        if (invoiceData[key] === null) {
          delete invoiceData[key];
        }
      }

      InvoiceService.getTaxAuthStatus(invoiceData).then(result => {
        if (typeof result?.tthai === 'number') {
          const formValue = getValue();
          taxAuthStatuses.forEach(stt => {
            if (stt.tthai === result.tthai) {
              formValue.invoiceStatus = stt.invoiceStatus;
              formValue.invoiceStatusText = stt.label;
            }
          });
          setValue(formValue);

          if (formValue.invoiceStatus === invoiceDetail.invoiceStatus) {
            setMessage({
              className: 'p-message-success',
              content: 'Trạng thái hóa đơn trùng khớp.'
            });
          } else {
            setMessage({
              className: 'p-message-warn',
              content: 'Trạng thái hóa đơn có thay đổi!'
            });
            setNeedUpdate(true);
          }
        }
      }).catch(err => {
        if (err?.response?.data?.error?.message) {
          setMessage({
            className: 'p-message-error',
            content: err?.response?.data?.error?.message
          });
        }
      }).finally(() => setSubmitting(false));
    }
  }

  const updateTaxAuthStatus = () => {
    if (!submitting) {
      setSubmitting(true);
      setMessage(null);
      setNeedUpdate(false);

      const formValue = getValue();

      InvoiceService.setTaxAuthStatus(formValue).then(() => {
        ToastService.success();
        setDisplay(false);
        props.refreshLazyData();
      }).catch(err => {
        setNeedUpdate(true);
        if (err?.response?.data?.error?.message) {
          setMessage({
            className: 'p-message-error',
            content: err?.response?.data?.error?.message
          });
        }
      }).finally(() => setSubmitting(false));
    }
  }

  const renderTaxAuthStatus = () => {
    return (
      <Dialog header="Cập nhật trạng thái hóa đơn từ CQT" visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="p-fluid formgrid grid">
          <div className="col-11">
            {renderForm()}
          </div>
        </div>

        {message && <div className={`p-message p-component ${message.className} p-message-enter-done`}>
					<div className="p-message-wrapper">
						<span className="p-message-icon pi pi-info-circle"></span>
						<span className="p-message-detail">{message.content}</span>
					</div>
				</div>}

        <div className="flex justify-content-end">
          <Button label="Kiểm tra trên CQT" icon="pi pi-search" onClick={getTaxAuthStatus} loading={submitting} className="p-button-sm p-button-outlined mr-2"/>
          <Button label="Cập nhật" icon="pi pi-check" onClick={updateTaxAuthStatus} loading={submitting} className="p-button-sm mr-2" disabled={!needUpdate}/>
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }

  return {renderTaxAuthStatus, showTaxAuthStatus};

}

const taxAuthStatuses = [
  {tthai: 1, invoiceStatus: 0, label: 'Gốc'},
  {tthai: 6, invoiceStatus: 1, label: 'Hủy'},
  {tthai: 3, invoiceStatus: 2, label: 'Điều chỉnh'},
  {tthai: 2, invoiceStatus: 3, label: 'Thay thế'},
  {tthai: 5, invoiceStatus: 5, label: 'Bị điều chỉnh'},
  {tthai: 4, invoiceStatus: 6, label: 'Bị thay thế'}
];